import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import styles from "./MainLayout.module.css";
import Footerbar from "./Footerbar";

const MainLayout = ({ isLoggedIn }) => {
  return (
    <div className={styles.mainLayout} style={{ display: "flex" }}>
      <Sidebar />
      <div className={styles.outletContainer}>
        <Outlet /> {/* This will render different pages */}
      </div>
      <Footerbar isLoggedIn={isLoggedIn} />
    </div>
  );
};

export default MainLayout;
